import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { FakeBackendProvider } from './core/helpers/fake-backend';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { EppModule } from './epp/epp.module';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { NgImageSliderModule } from 'ng-image-slider';
import { BnNgIdleService } from 'bn-ng-idle';
import { StaySigninComponent } from './stay-signin/stay-signin.component';
import { FranchiseModule } from './franchise/franchise.module';
import { TitleCasePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccountModule } from './account/account.module';
// import { AngularMaterialModule } from './angular-material.module';

// import { auctionRoutingModule } from './auction/auction-routing.module';

@NgModule({
    declarations: [AppComponent, StaySigninComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LayoutsModule,
        AppRoutingModule,
        GridModule,
        ReactiveFormsModule,
        DataTablesModule,
        EppModule,
        FranchiseModule,
        NgImageSliderModule,
        AngularMaterialModule,
        SharedModule,
        NgbModule,
        AccountModule,
        ToastrModule.forRoot(),
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        BnNgIdleService,
        FakeBackendProvider,
        TitleCasePipe,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
